import facebook from '../assets/images/icon-facebook.svg';
import twitter from '../assets/images/icon-twitter.svg';
import instagram from '../assets/images/icon-instagram.svg';
import pinterest from '../assets/images/icon-pinterest.svg';
import youtube from '../assets/images/icon-youtube.svg';

export const socialLinks = [
  { url: 'https://facebook.com', alt: 'Facebook', icon: facebook },
  { url: 'https://youtube.com', alt: 'YouTube', icon: youtube },
  { url: 'https://twitter.com', alt: 'Twitter', icon: twitter },
  { url: 'https://pinterest.com', alt: 'Pinterest', icon: pinterest },
  { url: 'httpS://instagram', alt: 'Instagram', icon: instagram },
];
